<app-presentation>
  <div class="ph-landing-card-texts d-flex flex-column">
    
    <div class="col-12" class="ph-landing-title">
      <h2>{{ 'base.title' | translate }}</h2>
    </div>

    <div class="col-12 text-left" class="ph-landing-text">
      <p>{{ 'base.text' | translate }}</p>
    </div>

    <div class="col-12 pl-0">
      <button routerLink="home" class="btn btn-primary btn-big  mr-3">{{ 'base.signin' | translate }}</button>

      <!--<button routerLink="register" class="btn btn-primary btn-big ">{{ 'base.register' | translate }}</button>-->
    </div>

    <!--
      <div class="col-12 pl-0">
        <p class="help-message">{{ 'base.helpMessage' | translate }}</p>

        <button class="btn btn-secondary mr-3">{{ 'base.about' | translate }}</button>

        <button class="btn btn-secondary">{{ 'base.helpAndsupport' | translate }}</button>
      </div>
    -->

  </div>
</app-presentation>
